import { useContent } from '@/context/ContentContext';

export default function Marquee() {
  const { t } = useContent();
  if (!t) return null;
  const text = t.marquee || '';
  return (
    <section
      data-testid="marquee-section"
      aria-hidden="true"
      className="relative border-y border-[var(--line)] py-6 sm:py-8 md:py-10 overflow-hidden bg-paper-2"
    >
      <div className="marquee-track">
        {new Array(2).fill(0).map((_, i) => (
          <span
            key={i}
            className="font-serif italic text-[13vw] sm:text-[10vw] md:text-[7vw] leading-none pr-8 sm:pr-10 md:pr-16 flex items-center"
          >
            <span className="text-ink">{text}</span>
            <span
              className="ml-6 md:ml-10"
              style={{
                WebkitTextStroke: '1px #f4efe6',
                color: 'transparent',
              }}
            >
              {text}
            </span>
          </span>
        ))}
      </div>
    </section>
  );
}
